import { render, staticRenderFns } from "./USU004_admPersonal.vue?vue&type=template&id=221ca28d&"
import script from "./USU004_admPersonal.vue?vue&type=script&lang=js&"
export * from "./USU004_admPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports